import { useEffect, useState } from 'react'
import styles from './style.module.css'
import FilterTab from './FilterTab'
import TagsTab from './TagsTab';

export default function ModelFilter({className,filter,onChange,onClear}){
    const [onMenu,setOnMenu]=useState("filter")

    return(
        <div className={`${styles['wrap']} ${className}`}>
            <div className={styles['header']}>
                <p 
                onClick={()=>setOnMenu("filter")}>
                    <span className={`${onMenu==="filter"&&styles['menu-on']}`}>Filter</span>
                    <div className={styles['header-icon-wrap']}>
                        {filter.filters.type.length!==0&&<div className={`${styles['header-icon']} ${styles['header-icon-type']}`}></div>}
                        {filter.filters.dataset.length!==0&&<div className={`${styles['header-icon']} ${styles['header-icon-dataset']}`}></div>}
                        {filter.filters.status.length!==0&&<div className={`${styles['header-icon']} ${styles['header-icon-status']}`}></div>}
                    </div>
                </p>
                <p
                onClick={()=>setOnMenu("tags")}>
                    <span className={`${onMenu==="tags"&&styles['menu-on']}`}>Tags</span>
                    {filter.filters.tags.length!==0&&<span className={styles['header-count']}>{filter.filters.tags.length}</span>}
                </p>
                {
                    <span 
                    className={`${               
                        (filter.filters.type.length===0&& 
                        filter.filters.dataset.length===0&&
                        filter.filters.status.length===0&& 
                        filter.filters.tags.length===0)&&
                    styles['btn-hide']}`}
                    onClick={onClear}
                    >Clear</span>
                }
            </div>
            <div className={styles['body']}>
                {onMenu==="filter"?
                <FilterTab
                filter={filter}
                onChange={onChange}
                />
                :
                <>
                <TagsTab
                filter={filter}
                onChange={onChange}
                />
                </>
                }
            </div>
        </div>
    )
}